import { useState } from 'react'
import { Link } from 'react-router-dom'
import Navigation from './Navigation'
import './Header.css'

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo-section">
          <Link to="/" className="logo">
            <img src="/images/healthy-living-logo.png" alt="Healthy Living logo" className="site-logo" />
            <h1>Healthy Living Blog</h1>
          </Link>
          <p className="tagline">Your guide to a healthier, sustainable lifestyle</p>
        </div>
        
        <button 
          className="menu-toggle" 
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <Navigation isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
      </div>
    </header>
  )
}

export default Header
